/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PortfolioPredictionSummary } from "../models/PortfolioPredictionSummary";
import type { ProjectDTO } from "../models/ProjectDTO";
import type { ProjectIdsPayload } from "../models/ProjectIdsPayload";
import type { ProjectIdsResponse } from "../models/ProjectIdsResponse";
import type { ProjectPredictionKeyFactors } from "../models/ProjectPredictionKeyFactors";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class ProjectService {
  /**
   * @param hasPredictions
   * @param hasOverrides
   * @param projectSearchText
   * @returns ProjectDTO
   * @throws ApiError
   */
  public static projectGetProjects(
    hasPredictions?: boolean | null,
    hasOverrides?: boolean | null,
    projectSearchText?: string | null
  ): CancelablePromise<Array<ProjectDTO>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Project/GetProjects",
      query: {
        hasPredictions: hasPredictions,
        hasOverrides: hasOverrides,
        projectSearchText: projectSearchText,
      },
    });
  }

  /**
   * @param requestBody
   * @returns ProjectIdsResponse
   * @throws ApiError
   */
  public static projectGetProjectIds(
    requestBody: ProjectIdsPayload
  ): CancelablePromise<ProjectIdsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Project/GetProjectIds",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param hasPredictions
   * @param hasOverrides
   * @param projectSearchText
   * @param id
   * @param pageSize
   * @param sortColumn
   * @param sortOrder
   * @param filterValue
   * @returns ProjectDTO
   * @throws ApiError
   */
  public static projectGetProjectsPaged(
    hasPredictions?: boolean | null,
    hasOverrides?: boolean | null,
    projectSearchText?: string | null,
    id?: number | null,
    pageSize?: number | null,
    sortColumn?: string | null,
    sortOrder?: string | null,
    filterValue?: string | null
  ): CancelablePromise<Array<ProjectDTO>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Project/GetProjectsPaged",
      query: {
        hasPredictions: hasPredictions,
        hasOverrides: hasOverrides,
        projectSearchText: projectSearchText,
        id: id,
        pageSize: pageSize,
        sortColumn: sortColumn,
        sortOrder: sortOrder,
        filterValue: filterValue,
      },
    });
  }

  /**
   * @returns PortfolioPredictionSummary
   * @throws ApiError
   */
  public static projectGetPortfolioPredictionSummary(): CancelablePromise<PortfolioPredictionSummary> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Project/GetPortfolioPredictionSummary",
    });
  }

  /**
   * @param projectId
   * @returns ProjectPredictionKeyFactors
   * @throws ApiError
   */
  public static projectGetProjectPredictionKeyFactors(
    projectId?: number
  ): CancelablePromise<Array<ProjectPredictionKeyFactors>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Project/GetProjectPredictionKeyFactors",
      query: {
        projectId: projectId,
      },
    });
  }
}
